import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const iconButtonVariants = cva(styles.iconButton, {
  variants: {
    variant: {
      primary: styles.primary,
      secondary: styles.secondary,
      destructive: styles.destructive,
      outline: styles.outline,
      ghost: styles.ghost,
      ghostDestructive: styles.ghostDestructive,
    },
    size: {
      xs: styles.xs,
      sm: styles.sm,
      md: styles.md,
      lg: styles.lg,
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
});
